export default __webpack_public_path__ + "static/media/cup-coach.7d26d6d2.png";